export default __webpack_public_path__ + "static/media/Cairo-Black.01001b13.ttf";